import { Link } from "react-router-dom";
import Flag from "react-world-flags";
import { Play } from "lucide-react";

const formatDateNum = (d) => {
  if (!d) return "";
  const [y, m, day] = d.split("-");
  return y && m && day ? `${day}/${m}/${y}` : d;
};

export default function VideoCard({ speech, featured = false }) {
  const thumb = speech.youtube_id
    ? `https://img.youtube.com/vi/${speech.youtube_id}/hqdefault.jpg`
    : "https://images.unsplash.com/photo-1561491431-71b89da6056a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800";

  return (
    <Link
      to={`/discorso/${speech.id}`}
      data-testid={`video-card-${speech.id}`}
      className="group block bg-card border border-border rounded-sm overflow-hidden hover:-translate-y-1 transition-transform duration-200 hover:border-primary/40"
    >
      <div className="relative aspect-video overflow-hidden bg-muted">
        <img
          src={thumb}
          alt={speech.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
        <div className="absolute top-3 right-3 flex items-center gap-2 text-white bg-black/60 backdrop-blur-sm px-2.5 py-1.5 rounded-sm max-w-[calc(100%-1.5rem)]">
          {speech.country_code && (
            <span className="w-6 h-4 overflow-hidden rounded-[2px] border border-white/30 shrink-0">
              <Flag code={speech.country_code} className="w-full h-full object-cover" fallback={<span />} />
            </span>
          )}
          <span className="text-xs font-semibold truncate">{speech.leader}</span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="h-12 w-12 rounded-full bg-white/90 flex items-center justify-center">
            <Play className="h-5 w-5 text-black fill-black ml-0.5" />
          </span>
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.15em] text-muted-foreground mb-2">
          {speech.theme && <span>{speech.theme}</span>}
          {speech.event_date && <span>· {formatDateNum(speech.event_date)}</span>}
        </div>
        <h3
          className={`font-serif font-semibold leading-snug group-hover:text-primary transition-colors ${
            featured ? "text-2xl" : "text-lg"
          }`}
        >
          {speech.title}
        </h3>
        {featured && speech.summary?.[0] && (
          <p className="text-sm text-muted-foreground mt-3 leading-relaxed line-clamp-2">
            {speech.summary[0]}
          </p>
        )}
      </div>
    </Link>
  );
}
